module.exports = __webpack_public_path__ + "media/images/category_icons/other_material-557f6c88b9a422c995c3a5c9299e38b5.svg";